import React from 'react';
import { message } from 'antd';

message.config({
    duration: 5,
    maxCount: 1,
});
export const errorHandler = (meta, text, t) => {
    message.error(
        <div>
            {text}<br />
            {t ? t(`errors.${meta.error.message}`) : meta.error.message}
        </div>
    );
};
